import React from "react";
import { ImagePicker } from 'react-file-picker'
import Cookies from "universal-cookie";
import { TwitterPicker } from 'react-color';
import IconTint from 'react-icon-tint';

export default class ImageInput extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            base64: this.props.value, 
            logoHover: false,
            colorOpen: false,
            selectedColor: this.props.color,
            onSelect: this.props.onSelect ? true : false,
        }
    }

    async componentDidMount() {
        var str = ("#" + new Cookies().get('secondaryColor', { path: '/' })).split('');
        str[2] = "0";
        str[4] = "0";
        str[6] = "0";
        this.darkerColor = str.join('');
        this.setState({ });
    }

    render () {

        const readOnly = this.props.readOnly;

        if (readOnly == true){
            return (
            <div style={this.mainClass}>
            <div style={this.name}>{this.props.name}</div>
            <div style={{
                backgroundImage: 'url("data:' + this.state.base64 + '")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                width: '150px',
                height: '150px',
                border: '1px solid darkgrey',
                borderRadius: '10px',
                marginBottom: '10px',
                display: this.state.base64 === undefined ? 'none' : 'block',

            }} >
            </div>
            </div>
        );
        }
        return ( 
        <div style={this.mainClass}>
            <div style={this.name}>{this.props.name}</div>
            <div style={{
                backgroundImage: 'url("data:' + this.state.base64 + '")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                width: '150px',
                height: '150px',
                border: '1px solid darkgrey',
                borderRadius: '10px',
                paddind: '5px',
                marginBottom: '10px',
                display: this.state.base64 === undefined ? 'none' : 'block',

            }} >
            </div>

            <ImagePicker
                extensions={['jpg', 'jpeg', 'png']}
                dims={{minWidth: 100, maxWidth: 3000, minHeight: 100, maxHeight: 3000}}
                onChange={base64 => {
                    this.setState({base64: base64});
                    if (this.props.onChange)
                        this.props.onChange(base64)
                }}
                onError={() => { } } >
                { !this.state.onSelect ? (<button style={{...this.selectBtn, backgroundColor: this.state.logoHover ? this.darkerColor : '#' + new Cookies().get('secondaryColor', { path: '/' })}} onMouseEnter={() => this.setState({ logoHover: true })} onMouseLeave={() => this.setState({ logoHover: false })}>Seleziona</button> ) : (<div/>)}
            </ImagePicker>

            { this.state.onSelect ? (<button style={{...this.selectBtn, backgroundColor: this.state.logoHover ? this.darkerColor : '#' + new Cookies().get('secondaryColor', { path: '/' })}} onClick={() => this.props.onSelect()} onMouseEnter={() => this.setState({ logoHover: true })} onMouseLeave={() => this.setState({ logoHover: false })}>Seleziona</button> ) : (<div/>)}

            <div style={{position: 'absolute', color: 'darkgrey', top: 25, right: 35, padding: 0, fontSize: '20px', cursor: 'pointer'}}
                onClick={() => {this.setState({base64: ''});
                        if (this.props.onChange)
                            this.props.onChange('')
                        if (this.props.setColor)
                            this.props.setColor('')
                        }
                    }
                >
                    <img src={ require('../images/close_icon.png') } style={{ width: 20, height: 20 }} title="Elimina immagine attuale" />
            </div>

            { this.props.colorButton === true && (
                <div style={{position: 'absolute', color: 'darkgrey', top: 50, right: 35, padding: 0, fontSize: '20px', cursor: 'pointer'}}
                    onClick={() => { this.setState({ colorOpen: !this.state.colorOpen });}} >
                        { this.state.selectedColor === '' && <img src={ require('../images/chromatic.png') } color={this.state.selectedColor} style={{ width: 20, height: 20, borderRadius: 10, backgroundColor: this.state.selectedColor === '' ? '' : this.state.selectedColor }} title="Seleziona un colore di sfondo" /> }
                        { this.state.selectedColor !== '' && <button style={{ width: 20, height: 20, backgroundColor: this.state.selectedColor, borderRadius: 10, marginTop: 6 }}></button>}
                </div>
            )}

            { this.state.colorOpen && (
                <div style={{ position: 'absolute', top: 95, left: 135 }}>
                    <TwitterPicker color={this.state.selectedColor} onChangeComplete={(color) => { this.setState({ selectedColor: color.hex, base64: color.hex }); this.props.setColor(color.hex) }} />
                </div>
            )}
        </div>
        )
    }

    mainClass = {
        padding: '10px',
        width: '200px',
        position: 'relative', 
    }
    
    name = {
        marginBottom: '5px',
        color: 'darkgrey', 
        fontWeight: 'bold', 
        fontFamily: 'Fredoka One',
    }
    
    selectBtn = {
        color: 'white',
        fontSize: 18,
        width: '150px',
        height: '40px',
        border: 0,
        boxShadow: '0px 2px 8px lightgrey',
        borderRadius: '10px',
        cursor: 'pointer',
    }
    
    picture = {
    
    
    }
    
    inputText = {
        width: '300px'
    }

}